import { transformRecordToOption } from '@/utils/common';
import type { CommonType } from '@/typings/common';

/** Disabled时仍然显示的组件 */
export const ShowWhenDisabledComponents: CommonType.ComponentType[] = [
  'NTree',
  'BasicUpload',
  'TagCheckbox',
  'BasicTable',
  'MixedTableForm',
  'WangEditor',
  'NTransfer'
];

export const YesOrNoRecords: Record<number, string> = {
  1: '是',
  0: '否'
};

export const YesOrNoOptions = transformRecordToOption(YesOrNoRecords, 'number');
